import { useTheme } from '@emotion/react'
import BreadcrumbHeader from 'layout/BreadcrumbsHeader'
import React, { useCallback, useState } from 'react'
import NeedHelpButton from 'ui-components/NeedHelpButton'
import ThemeBGWrapper from 'ui-components/ThemeBGWrapper'
import CustomTabs from 'ui-components/CustomTabs'
import { TabContext } from '@mui/lab'
import AsyncTableListing from 'ui-components/AsyncTableListing'
import { Box, Grid, Button, MenuItem, Select, InputAdornment, IconButton, useMediaQuery, Autocomplete, Tooltip } from '@mui/material'
import CustomInputField from 'ui-components/CustomInputField'
import { Search as SearchIcon, Visibility as VisibilityIcon, Receipt as ReceiptIcon, Search, FilterAltRounded, FilterAltOutlined } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { makeStyles } from '@mui/styles'
import { Primary, Secondary } from 'ui-components/Buttons';import ModalComponent from 'ui-components/ModalComponent'
import FilterPopup from './popups/FilterPopup'
import Cookies from 'js-cookie'
import { FetchAllPurchases, FetchInvoices } from 'api/startup_purchases'
import moment from 'moment'
import { capitalizedSentence } from 'utils/index'
import placeHolderImage from "assets/no_data_images/BackrrStartups/no_data_feedbacks_views.svg"

const useStyles = makeStyles((theme) => ({
  scrollTabs: {
    "&": {
      padding: "3rem"
    }
    // '& .MuiTabs-root > .MuiTabs-scroller > .MuiTabs-flexContainer' : {marginLeft: '2rem', gap: '5rem'}
  }
  //     '& .MuiTabs-root > .Mui-disabled.MuiTabs-scrollButtons': {
  //         display: 'none !important',
  //         transition: 'all 1s ease'
  //     },
  // }
}));

const OneTimePurchases = ({ tabValue = "one_time", setLoading = () => { }, setCount = () => { } }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const classes = useStyles();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  const paginationCookie = "backrr_one_time_purchases_pagination";
  const searchCookie = "backrr_one_time_purchases_search";
  const filtersCookie = "backrr_one_time_purchases_filters";

  const [search, setSearch] = React.useState(Cookies.get(searchCookie) || '')
  const [searchStatus, setSearchStatus] = React.useState(!!Cookies.get(searchCookie))
  const [reset, setReset] = React.useState(false)
  const [page, setPage] = React.useState(Number(Cookies.get(paginationCookie)) || 1);
  const [limit, setLimit] = React.useState(10);
  const [queryParams, setQueryParams] = React.useState(() => {
    const savedFilters = Cookies.get(filtersCookie);
    return savedFilters ? JSON.parse(savedFilters) : {};
  });

  const purchasesColumns = React.useMemo(() => ([ 
    { Header: 'Startup Name', accessor: 'name', id: 'name', minWidth: 260 },
    { Header: 'Purchase Date', accessor: 'purchase_date', id: 'purchase_date', minWidth: 140, align: 'center' },
    { Header: 'Report Name', accessor: 'resolved_title', id: 'resolved_title', minWidth: 220, align: 'center' },
    { Header: 'Amount Paid', accessor: 'amount_paid', id: 'amount_paid', minWidth: 120, align: 'center' },
    { Header: 'View', accessor: 'actions', id: 'actions', minWidth: 100, align: 'center' }
  ]), []);

  const { mutateAsync: fetchInvoicesAsync, } = FetchInvoices()

  const OneTimeRowActions = ({ row }) => {
      const openReport = () => {
          const url = row?.original?.invoice_url
          if (url) window.open(url, '_blank')
      }
      return (
          row?.original?.invoice_url ?  <IconButton onClick={openReport} size={isSmall ? 'small' : 'medium'}>
              <VisibilityIcon />
          </IconButton> : "-"
      )
  }

  const CustomLink = ({ children, row }) => {
    return (
      <Box
        onClick={() => {
            Cookies.set("startup_id", row?.original?.startup_id);
            navigate(`/backrr_startups/view-profile`);
        }}
        sx={{ cursor: 'pointer' }}>
        {children}
      </Box>
    )
  }

  const { data: purchases, isLoading: isLoadingPurchases, isRefetching: isRefetchingPurchases, refetch: refetchPurchases } = FetchAllPurchases({ page, limit, search: searchStatus ? search : "", queryParams });

  const refetchListing = useCallback(() => {
    refetchPurchases();
  }, [refetchPurchases])

  React.useEffect(() => {
    refetchListing();
  }, [reset]);

  React.useEffect(() => {
    setCount(purchases?.meta?.total)
  }, [purchases?.meta?.total])

  const purchasesData = purchases?.data?.map((row) => {
    // const 
    return ({
      name: row?.startup_name,
      image: row?.startup_logo,
      email: row?.startup_email,
      purchase_date: moment(row?.created_at)?.format("DD-MMM-YYYY HH:mm:ss"),
      amount_paid: (row?.currency === "INR" ? "₹" : "$") + row?.amount,
      ...row
    })
  }) || [];

  const [filterToggle, setFilterToggle] = useState(false);

  // Cross inside the search field: clears the search term only, filters are
  // reset from the filter popup.
  const handleSearchReset = () => {
    setSearch('');
    Cookies.remove(searchCookie);
    setSearchStatus(false);
    setPage(1);
    Cookies.set(paginationCookie, 1);
    setReset(!reset);
  }

  const handleFilterOpen = () => {
    setFilterToggle(true);
  }

  const handleFilterClose = () => {
    setFilterToggle(false);
  }

  const handleFilterSubmit = ({ query }) => {
    setQueryParams(query);
    Cookies.set(filtersCookie, JSON.stringify(query));
    setReset(!reset);
    setPage(1);
    setFilterToggle(false);
  }

  const handleFilterReset = () => {
    setQueryParams({});
    Cookies.remove(filtersCookie);
    setReset(!reset);
    setPage(1);
    setFilterToggle(false);
  }

  return (
    <>
      <ModalComponent open={filterToggle} onClose={handleFilterClose} style={{ maxWidth: 700, width: "100%" }}>
        <FilterPopup
          tabValue={tabValue}
          queryParams={queryParams || {}}
          setQueryParams={setQueryParams}
          handleClose={handleFilterClose}
          handleSubmit={handleFilterSubmit}
          handleReset={handleFilterReset}
        />
      </ModalComponent>


      {/* <Box sx={{ padding: '1rem 2rem' }}> */}
      <Grid container padding={"0.5rem"} marginTop={2} sx={{
        border: `1px solid ${theme.palette.customColors.b50} !important`,
        borderRadius: '8px 8px 0px 0px',
        background: theme?.palette.customColors.whiteBG, gap: "0.5rem"
      }}>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4} style={{ display: 'flex', height: 'min-content', alignItems: 'center', gap: "0.5rem" }}>

          <CustomInputField
            autoComplete="off"
            sx={{
              marginBottom: 0,
              "& > .MuiFilledInput-root": {
                borderColor: `${theme.palette.customColors.b50} !important`,
                borderRadius: '8px'
              },
              ":disabled": {
                bgcolor: theme.palette.customColors.b300,
                color: theme.palette.customColors.whiteBG
              },
            }}
            // disabled={value === "subscribed"}
            fullWidth
            value={search}
            name={`search_${Math.random().toString(36).substring(7)}`}  // Set a random name attribute
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                Cookies.set(searchCookie, search);
                refetchListing();
                if (search) {
                  setSearchStatus(true)
                }
                setPage(1);
                Cookies.set(paginationCookie, 1)
              }
            }}
            onChange={(event) => {
              setSearch(event.target.value);
              setSearchStatus(false)
            }}
            size="small"
            startAdornment={<>
              <Search sx={{ padding: "0rem 0rem 0rem 0.5rem" }} />
            </>}
            onClear={handleSearchReset}
            placeholder={'Search by Startup Name or email'}
          />
          {<Tooltip title="Filter" >
            <IconButton sx={{ marginLeft: "auto", display: { xs: 'flex', md: "flex" }, marginBlock: 'auto' }} onClick={() => handleFilterOpen()}>
              {Object.keys(queryParams)?.length > 0 ? <FilterAltRounded sx={{ color: theme?.palette?.customColors.indigo700 }} /> : <FilterAltOutlined />}
            </IconButton>
          </Tooltip>}
        </Grid>
      </Grid>

      {(isLoadingPurchases || isRefetchingPurchases) ? <>

        <Grid item xs={12} height={"100dvh"} sx={{ width: 'calc(100% - 2px)', bgColor: theme.palette.customColors.yellow_bg }} paddingInline={"0rem !important"}>
          <Box className='skeleton' minHeight={"100dvh"} sx={{ borderRadius: "0px 0px 8px 8px", border: `1px solid ${theme.palette.customColors.b50}` }} marginTop={0}>

          </Box>
        </Grid>

      </> : (
        <AsyncTableListing
          columns={purchasesColumns}
          data={purchasesData}
          // title={'One-Time Purchases'}
          CustomLink={CustomLink}
          RowActions={({ cell, row }) => <OneTimeRowActions row={row} />}
          count={purchases.meta?.total}
          sx={{
            borderRadius: "0px 0px 8px 8px"
          }}
          maxHeight={purchases.meta?.total > 10 ? "calc(-20.5rem + 100dvh)" : "calc(100dvh - 16rem)"}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          refetchListing={refetchListing}
          reset={reset}
          noDataPlaceHolderImage={placeHolderImage}
          noDataTitle='No Results Found'
          noDataSubTitle='Try adjusting your filters to see relevant data.'
        />
      )}
      {/* </Box> */}
    </>
  )
}

export default OneTimePurchases